import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import  './header.css'
import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import {Link,NavLink,withRouter} from 'react-router-dom'
import {HomeRounded, Telegram} from "@material-ui/icons";
import ResumData from '../utils/ResumeData'
import ResumeData from "../utils/ResumeData";
import CustomButton from "../Button/Button";
import TelegramIcon from '@material-ui/icons/Telegram';
import GetAppIcon from "@material-ui/icons/GetApp";
const Header = (props) =>  {
    const pathname = props?.location?.pathname
    return (
        <Navbar bg="light" expand="lg" sticky='top' className='header'>
          <Nav.Link  as={NavLink} to='/' className='header_nav_link'>
              <Navbar.Brand className={'header_home'}>
                   <HomeRounded />
              </Navbar.Brand>
          </Nav.Link>


            <Navbar.Toggle />

            <Navbar.Collapse>
                <Nav className="header_nav">
                    <Nav.Link as={NavLink} to='' className={pathname  == '/' ? 'header_link_active' : 'header_link'}>
                        Resume
                    </Nav.Link>
                </Nav>
                <Nav>
                    <Nav.Link as={NavLink} to='/portfolio' className={pathname  == '/portfolio' ? 'header_link_active' : 'header_link'}>
                        Portfolio
                    </Nav.Link>
                </Nav>

                <div className='header_right'>
                    {Object.keys(ResumeData.socials).map((key) => (
                        <a href={ResumeData.socials[key].link} target='_blank'>
                            {ResumeData.socials[key].icon}
                        </a>
                    ))}
                    {/*<CustomButton text={'Hire Me'} icon={<TelegramIcon />} />*/}
                    <a target="_blank" href={ResumeData.cv} className="custom_btn custom_btn_link"  >
                        <span className='btn_text'>Hire Me <TelegramIcon /> </span>
                    </a>
                </div>
            </Navbar.Collapse>
        </Navbar>
    );
}

export default withRouter(Header);